"use client";

import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./FAQ.css";

const FAQ = ({ data }) => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (id) => {
    setActiveFAQ(activeFAQ === id ? null : id);
  };

  if (!data) return null;

  return (
    <div className="faq-container">
      <div className="faq-content">
        <div className="faq-list">
          {data.map((item) => (
            <div key={item.id} className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleFAQ(item.id)}
              >
                <span className="question-text">{item.question}</span>
                <span className="chevron-icon">
                  {activeFAQ === item.id ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </button>

              {activeFAQ === item.id && (
                <div className="faq-answer">
                  {item.answer.map((line, index) => (
                    <div key={index} className="answer-text">
                      {line}
                    </div>
                  ))}

                  {item.images && (
                    <div className="faq-images">
                      {item.images.map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`FAQ ${item.id} image ${index + 1}`}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
